import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Style from './Style.css';
export default (function (_a) {
    var color = _a.color, icon = _a.icon, title = _a.title, children = _a.children;
    return _jsxs("blockquote", { style: { borderLeftColor: color }, className: Style.blockquote, children: [_jsxs("div", { className: Style.title, children: [icon, " ", _jsx("span", { className: Style.titleContent, style: { color: color }, children: title })] }), _jsx("div", { children: children })] });
});
